/* eslint-disable */
import { useEffect, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import {
  Grid,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  Button,
  Tab,
  Tabs,
  TextField,
  Checkbox,
  Typography,
  useTheme,
} from '@mui/material';

import useSettings from '../../hooks/useSettings';
import { i18n } from '../../translate/i18n';
import useCompanySettings from '../../hooks/useSettings/companySettings';
import api from '../../services/api';
import { getStyled } from './styles';

const INITIAL_VALUES = {
  userCreation: 'disabled',
  SendGreetingAccepted: 'enabled',
  UserRandom: 'enabled',
  SettingsTransfTicket: 'enabled',
  AcceptCallWhatsapp: 'enabled',
  sendSignMessage: 'enabled',
  sendGreetingMessageOneQueues: 'enabled',
  sendQueuePosition: 'enabled',
  sendFarewellWaitingTicket: 'enabled',
  acceptAudioMessageContact: 'enabled',
  enableLGPD: 'disabled',
  lgpdMessage: '',
  lgpdLink: '',
  lgpdDeleteMessage: 'disabled',
  lgpdConsent: 'disabled',
  lgpdHideNumber: 'disabled',
  requiredTag: 'enabled',
  closeTicketOnTransfer: false,
  transferMessage: '',
  greetingAcceptedMessage: '',
  AcceptCallWhatsappMessage: '',
  sendQueuePositionMessage: '',
  showNotificationPending: false,
};

const INITIAL_WORK_TIME = {
  1: null,
  2: null,
  3: null,
  4: null,
  5: null,
  6: null,
  0: null,
};

export default function Options({ oldSettings, settings, user }) {
  const theme = useTheme();
  const classes = getStyled(theme);

  const [values, setValues] = useState(INITIAL_VALUES);
  const [loadings, setLoadings] = useState({});
  const [workTime, setWorkTime] = useState(INITIAL_WORK_TIME);

  const { update: updateUserCreation } = useSettings();
  const { update } = useCompanySettings();

  const isSuper = () => user.super;

  const setLoading = useCallback((key, value) => {
    setLoadings((prev) => ({ ...prev, [key]: value }));
  }, []);

  const setValue = useCallback((key, value) => {
    setValues((prev) => ({ ...prev, [key]: value }));
  }, []);

  useEffect(() => {
    if (Array.isArray(oldSettings) && oldSettings.length) {
      const userPar = oldSettings.find((s) => s.key === 'userCreation');
      if (userPar) setValue('userCreation', userPar.value);
    }
  }, [oldSettings, setValue]);

  useEffect(() => {
    const map = {
      acceptCallWhatsapp: 'AcceptCallWhatsapp',
      userRandom: 'UserRandom',
      sendGreetingMessageOneQueues: 'sendGreetingMessageOneQueues',
      sendSignMessage: 'sendSignMessage',
      sendFarewellWaitingTicket: 'sendFarewellWaitingTicket',
      sendGreetingAccepted: 'SendGreetingAccepted',
      sendQueuePosition: 'sendQueuePosition',
      acceptAudioMessageContact: 'acceptAudioMessageContact',
      enableLGPD: 'enableLGPD',
      requiredTag: 'requiredTag',
      lgpdDeleteMessage: 'lgpdDeleteMessage',
      lgpdHideNumber: 'lgpdHideNumber',
      lgpdConsent: 'lgpdConsent',
      lgpdMessage: 'lgpdMessage',
      sendMsgTransfTicket: 'SettingsTransfTicket',
      lgpdLink: 'lgpdLink',
      closeTicketOnTransfer: 'closeTicketOnTransfer',
      transferMessage: 'transferMessage',
      greetingAcceptedMessage: 'greetingAcceptedMessage',
      AcceptCallWhatsappMessage: 'AcceptCallWhatsappMessage',
      sendQueuePositionMessage: 'sendQueuePositionMessage',
      showNotificationPending: 'showNotificationPending',
    };

    const updates = {};
    for (const [key, value] of Object.entries(settings)) {
      if (map[key]) updates[map[key]] = value;
    }
    if (Object.keys(updates).length) {
      setValues((prev) => ({ ...prev, ...updates }));
    }

    if (settings?.workTime && Object.keys(settings.workTime).length > 0) {
      setWorkTime((prev) => ({ ...prev, ...settings.workTime }));
    }
  }, [settings]);

  const handleOldSetting = async (key, stateKey, value) => {
    setValue(stateKey, value);
    setLoading(stateKey, true);
    await updateUserCreation({ key, value });
    setLoading(stateKey, false);
  };

  const handleSetting = async (column, stateKey, value) => {
    setValue(stateKey, value);
    setLoading(stateKey, true);
    await update({ column, data: value });
    setLoading(stateKey, false);
  };

  const handleUpdateWorkTime = async () => {
    const workTimeToSave = {};
    Object.keys(workTime).forEach((day) => {
      if (workTime[day]?.startTime && workTime[day]?.endTime) {
        workTimeToSave[day] = {
          startTime: workTime[day].startTime,
          endTime: workTime[day].endTime,
        };
      }
    });
    try {
      await api.post('/companySettings/workTime', workTimeToSave);
      toastSuccess('Horários salvos com sucesso!');
    } catch {
      toastError('Erro ao salvar horários');
    }
  };

  const handleCheckboxChange = (dayId, checked) => {
    setWorkTime((prev) => ({
      ...prev,
      [dayId]: checked ? { startTime: '09:00', endTime: '18:00' } : null,
    }));
  };

  const handleTimeChange = (dayId, field, value) => {
    setWorkTime((prev) => ({
      ...prev,
      [dayId]: { ...prev[dayId], [field]: value },
    }));
  };

  const SettingSelect = ({
    label,
    stateKey,
    column,
    isOld = false,
    options,
  }) => (
    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
      <FormControl sx={classes.selectContainer}>
        <InputLabel id={`${stateKey}-label`} sx={theme.custom.label}>
          {label}
        </InputLabel>
        <Select
          sx={theme.custom.selectField}
          labelId={`${stateKey}-label`}
          label={label}
          value={values[stateKey]}
          onChange={async (e) => {
            if (isOld) await handleOldSetting(column, stateKey, e.target.value);
            else await handleSetting(column, stateKey, e.target.value);
          }}
          MenuProps={theme.custom.menuProps}
        >
          {options.map((opt) => (
            <MenuItem key={String(opt.value)} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>
          {loadings[stateKey] && i18n.t('settings.settings.options.updating')}
        </FormHelperText>
      </FormControl>
    </Grid>
  );

  const enabledDisabledOptions = [
    { value: 'disabled', label: i18n.t('settings.settings.options.disabled') },
    { value: 'enabled', label: i18n.t('settings.settings.options.enabled') },
  ];

  const yesNoOptions = [
    { value: false, label: i18n.t('settings.settings.options.disabled') },
    { value: true, label: i18n.t('settings.settings.options.enabled') },
  ];

  return (
    <>
      <Grid spacing={3} container sx={{ border: '10px #FFF' }}>
        {isSuper() && (
          <SettingSelect
            label={i18n.t('settings.settings.options.creationCompanyUser')}
            stateKey='userCreation'
            column='userCreation'
            isOld
            options={enabledDisabledOptions}
          />
        )}
        <SettingSelect
          label={i18n.t('settings.settings.options.sendGreetingAccepted')}
          stateKey='SendGreetingAccepted'
          column='sendGreetingAccepted'
          options={enabledDisabledOptions}
        />
        <SettingSelect
          label={i18n.t('settings.settings.options.userRandom')}
          stateKey='UserRandom'
          column='userRandom'
          options={enabledDisabledOptions}
        />
        <SettingSelect
          label={i18n.t('settings.settings.options.sendMsgTransfTicket')}
          stateKey='SettingsTransfTicket'
          column='sendMsgTransfTicket'
          options={enabledDisabledOptions}
        />
        <SettingSelect
          label={i18n.t('settings.settings.options.acceptCallWhatsapp')}
          stateKey='AcceptCallWhatsapp'
          column='acceptCallWhatsapp'
          options={enabledDisabledOptions}
        />
        <SettingSelect
          label={i18n.t('settings.settings.options.sendSignMessage')}
          stateKey='sendSignMessage'
          column='sendSignMessage'
          options={enabledDisabledOptions}
        />
        <SettingSelect
          label={i18n.t(
            'settings.settings.options.sendGreetingMessageOneQueues',
          )}
          stateKey='sendGreetingMessageOneQueues'
          column='sendGreetingMessageOneQueues'
          options={enabledDisabledOptions}
        />
        <SettingSelect
          label={i18n.t('settings.settings.options.sendQueuePosition')}
          stateKey='sendQueuePosition'
          column='sendQueuePosition'
          options={enabledDisabledOptions}
        />
        <SettingSelect
          label={i18n.t('settings.settings.options.sendFarewellWaitingTicket')}
          stateKey='sendFarewellWaitingTicket'
          column='sendFarewellWaitingTicket'
          options={enabledDisabledOptions}
        />
        <SettingSelect
          label={i18n.t('settings.settings.options.acceptAudioMessageContact')}
          stateKey='acceptAudioMessageContact'
          column='acceptAudioMessageContact'
          options={enabledDisabledOptions}
        />
        <SettingSelect
          label={i18n.t('settings.settings.options.enableLGPD')}
          stateKey='enableLGPD'
          column='enableLGPD'
          options={enabledDisabledOptions}
        />
        <SettingSelect
          label={i18n.t('settings.settings.options.requiredTag')}
          stateKey='requiredTag'
          column='requiredTag'
          options={enabledDisabledOptions}
        />
        <SettingSelect
          label={i18n.t('settings.settings.options.closeTicketOnTransfer')}
          stateKey='closeTicketOnTransfer'
          column='closeTicketOnTransfer'
          options={yesNoOptions}
        />
        <SettingSelect
          label={i18n.t('settings.settings.options.showNotificationPending')}
          stateKey='showNotificationPending'
          column='showNotificationPending'
          options={yesNoOptions}
        />
      </Grid>

      <br />

      {values.enableLGPD === 'enabled' && (
        <>
          <Grid spacing={3} container sx={{ marginBottom: 10 }}>
            <Tabs
              value={0}
              sx={{
                ...classes.tab,
                '& .MuiTab-root': { color: theme.custom.colors.text },
                '& .Mui-selected': { color: theme.custom.colors.text },
                '& .MuiTabs-indicator': {
                  backgroundColor: theme.custom.colors.text,
                },
              }}
              scrollButtons='on'
              variant='scrollable'
            >
              <Tab label={i18n.t('settings.settings.LGPD.title')} />
            </Tabs>
          </Grid>
          <Grid spacing={1} container>
            <Grid size={{ xs: 12, sm: 6, md: 12 }}>
              <FormControl sx={classes.selectContainer}>
                <TextField
                  multiline
                  rows={3}
                  label={i18n.t('settings.settings.LGPD.welcome')}
                  variant='outlined'
                  value={values.lgpdMessage}
                  onChange={async (e) =>
                    handleSetting('lgpdMessage', 'lgpdMessage', e.target.value)
                  }
                  sx={theme.custom.textField}
                  margin='dense'
                />
                <FormHelperText>
                  {loadings.lgpdMessage &&
                    i18n.t('settings.settings.options.updating')}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 12 }}>
              <FormControl sx={classes.selectContainer}>
                <TextField
                  label={i18n.t('settings.settings.LGPD.linkLGPD')}
                  variant='outlined'
                  value={values.lgpdLink}
                  onChange={async (e) =>
                    handleSetting('lgpdLink', 'lgpdLink', e.target.value)
                  }
                  sx={theme.custom.textField}
                  margin='dense'
                />
                <FormHelperText>
                  {loadings.lgpdLink &&
                    i18n.t('settings.settings.options.updating')}
                </FormHelperText>
              </FormControl>
            </Grid>
            <SettingSelect
              label={i18n.t('settings.settings.LGPD.obfuscateMessageDelete')}
              stateKey='lgpdDeleteMessage'
              column='lgpdDeleteMessage'
              options={enabledDisabledOptions}
            />
            <SettingSelect
              label={i18n.t('settings.settings.LGPD.alwaysConsent')}
              stateKey='lgpdConsent'
              column='lgpdConsent'
              options={enabledDisabledOptions}
            />
            <SettingSelect
              label={i18n.t('settings.settings.LGPD.obfuscatePhoneUser')}
              stateKey='lgpdHideNumber'
              column='lgpdHideNumber'
              options={enabledDisabledOptions}
            />
          </Grid>
        </>
      )}

      {/* Horários de trabalho — sem alterações na lógica */}
      <Grid
        spacing={1}
        container
        sx={{ margin: '15px 0', justifyContent: 'center' }}
      >
        {[
          {
            side: 'left',
            days: [
              { id: 1, label: 'Segunda-Feira' },
              { id: 2, label: 'Terça-Feira' },
              { id: 3, label: 'Quarta-Feira' },
              { id: 4, label: 'Quinta-Feira' },
            ],
          },
          {
            side: 'right',
            days: [
              { id: 5, label: 'Sexta-Feira' },
              { id: 6, label: 'Sábado' },
              { id: 0, label: 'Domingo' },
            ],
          },
        ].map(({ side, days }) => (
          <Grid
            key={side}
            size={{ xs: 12, sm: 8, md: 6 }}
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            <div style={{ maxWidth: '400px', width: '100%' }}>
              {days.map((day) => (
                <div
                  key={day.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    marginBottom: 10,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    <Checkbox
                      onChange={(e) =>
                        handleCheckboxChange(day.id, e.target.checked)
                      }
                      checked={workTime[day.id] !== null}
                      sx={{
                        padding: 0,
                        color: theme.custom.colors.text,
                        '&.Mui-checked': { color: theme.custom.colors.text },
                      }}
                    />
                    <Typography
                      variant='h6'
                      sx={{
                        color: theme.custom.colors.text,
                        minWidth: '120px',
                        fontSize: '17px',
                      }}
                    >
                      {day.label}
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    <TextField
                      label='Início'
                      type='time'
                      value={workTime[day.id]?.startTime || '09:00'}
                      onChange={(e) =>
                        handleTimeChange(day.id, 'startTime', e.target.value)
                      }
                      disabled={workTime[day.id] === null}
                      variant='outlined'
                      margin='dense'
                      size='small'
                      sx={{ ...theme.custom.textField, width: '120px' }}
                    />
                    <TextField
                      label='Fim'
                      type='time'
                      value={workTime[day.id]?.endTime || '18:00'}
                      onChange={(e) =>
                        handleTimeChange(day.id, 'endTime', e.target.value)
                      }
                      disabled={workTime[day.id] === null}
                      variant='outlined'
                      margin='dense'
                      size='small'
                      sx={{ ...theme.custom.textField, width: '120px' }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                </div>
              ))}
              {side === 'right' && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: 10,
                  }}
                >
                  <Button
                    variant='outlined'
                    sx={theme.custom.confirmButton}
                    onClick={handleUpdateWorkTime}
                  >
                    Salvar
                  </Button>
                </div>
              )}
            </div>
          </Grid>
        ))}
      </Grid>

      <Grid spacing={1} container>
        {[
          {
            id: 'transferMessage',
            stateKey: 'transferMessage',
            column: 'transferMessage',
            label: i18n.t('settings.settings.customMessages.transferMessage'),
            required: values.SettingsTransfTicket === 'enabled',
          },
          {
            id: 'greetingAcceptedMessage',
            stateKey: 'greetingAcceptedMessage',
            column: 'greetingAcceptedMessage',
            label: i18n.t(
              'settings.settings.customMessages.greetingAcceptedMessage',
            ),
            required: values.SendGreetingAccepted === 'enabled',
          },
          {
            id: 'AcceptCallWhatsappMessage',
            stateKey: 'AcceptCallWhatsappMessage',
            column: 'AcceptCallWhatsappMessage',
            label: i18n.t(
              'settings.settings.customMessages.AcceptCallWhatsappMessage',
            ),
            required: values.AcceptCallWhatsapp === 'disabled',
          },
          {
            id: 'sendQueuePositionMessage',
            stateKey: 'sendQueuePositionMessage',
            column: 'sendQueuePositionMessage',
            label: i18n.t(
              'settings.settings.customMessages.sendQueuePositionMessage',
            ),
            required: values.sendQueuePosition === 'enabled',
          },
        ].map(({ id, stateKey, column, label, required }) => (
          <Grid key={id} size={{ xs: 12, sm: 6, md: 6 }}>
            <FormControl sx={classes.selectContainer}>
              <TextField
                id={id}
                name={id}
                margin='dense'
                multiline
                rows={3}
                label={label}
                variant='outlined'
                value={values[stateKey]}
                required={required}
                onChange={async (e) =>
                  handleSetting(column, stateKey, e.target.value)
                }
                sx={theme.custom.textField}
              />
              <FormHelperText>
                {loadings[stateKey] &&
                  i18n.t('settings.settings.options.updating')}
              </FormHelperText>
            </FormControl>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
